document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-helm-testimonials]').forEach((section) => {
    if (section.dataset.initialized === 'true') return;

    section.dataset.initialized = 'true';

    const slides = [...section.querySelectorAll('[data-testimonial-slide]')];
    const previous = section.querySelector('[data-testimonial-prev]');
    const next = section.querySelector('[data-testimonial-next]');
    const progress = section.querySelector(
      '[data-testimonial-progress-active]'
    );

    if (slides.length < 2) return;

    let current = 0;

    const showSlide = (index) => {
      current = Math.max(0, Math.min(index, slides.length - 1));

      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === current);
      });

      if (progress) {
        progress.style.transform = `translateX(${current * 100}%)`;
      }

      if (previous) {
        const isFirst = current === 0;

        previous.classList.toggle('is-disabled', isFirst);
        previous.disabled = isFirst;
      }

      if (next) {
        const isLast = current === slides.length - 1;

        next.classList.toggle('is-disabled', isLast);
        next.disabled = isLast;
      }
    };

    previous?.addEventListener('click', () => {
      showSlide(current - 1);
    });

    next?.addEventListener('click', () => {
      showSlide(current + 1);
    });

    showSlide(0);
  });
});